// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"c7e6c7b9","5175":"c7e6c7b9","7556":"c7e6c7b9","7967":"c7e6c7b9"}[chunkId] + ".chunk.css";
};